import {ApolloProvider, makeGorillaApolloClient} from '@wandb/weave/apollo';
import {WFDataModelAutoProvider} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/wfReactInterface/context';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useMemo} from 'react';

import {DatasetsSection} from './DatasetsSection';
import {ModelsSection} from './ModelsSection';
import {RecentEvaluations} from './RecentEvaluations';
import {RecentTraces} from './RecentTraces';
import {StatsOverview} from './StatsOverview';
import {WeaveProjectTabProps} from './types';

const WeaveProjectTabInner: React.FC<WeaveProjectTabProps> = ({
  entityName,
  projectName,
}) => {
  return (
    <Tailwind>
      <div className="mx-auto max-w-[1400px] px-32 py-32">
        <StatsOverview entityName={entityName} projectName={projectName} />

        <div className="flex flex-col gap-32">
          <div className="grid grid-cols-2 gap-32">
            <RecentTraces entityName={entityName} projectName={projectName} />
            <RecentEvaluations
              entityName={entityName}
              projectName={projectName}
            />
          </div>
          <div className="grid grid-cols-2 gap-32">
            <ModelsSection entityName={entityName} projectName={projectName} />
            <DatasetsSection
              entityName={entityName}
              projectName={projectName}
            />
          </div>
        </div>
      </div>
    </Tailwind>
  );
};

/**
 * Main entry point for the Weave Project Tab component.
 * Provides necessary context providers (Apollo, WFDataModel) for child components.
 */
export const WeaveProjectTab: React.FC<WeaveProjectTabProps> = ({
  entityName,
  projectName,
}) => {
  const apolloClient = useMemo(() => makeGorillaApolloClient(), []);

  return (
    <ApolloProvider client={apolloClient}>
      <WFDataModelAutoProvider>
        <WeaveProjectTabInner
          entityName={entityName}
          projectName={projectName}
        />
      </WFDataModelAutoProvider>
    </ApolloProvider>
  );
};
